var map = {
	"./UOB-B2CTest.png": 809,
	"./affin-B2CTest.png": 810,
	"./affin-islamic.png": 811,
	"./affin.png": 812,
	"./agrobank.png": 813,
	"./alliance-islamic.png": 814,
	"./alliance.png": 815,
	"./ambank-islamic.png": 816,
	"./ambank.png": 817,
	"./bank-islam.png": 818,
	"./bank-rakyat.png": 819,
	"./bnp-r.png": 820,
	"./boc.png": 821,
	"./bsn.png": 822,
	"./cimb-islamic.png": 823,
	"./cimb.png": 824,
	"./citibank.png": 825,
	"./deutsche-r.png": 826,
	"./hongleong-islamic.png": 827,
	"./hongleong.png": 828,
	"./hsbc-amanah.png": 829,
	"./hsbc.png": 830,
	"./kfh.png": 831,
	"./maybank-islamic.png": 832,
	"./maybank.png": 833,
	"./mbb0228.png": 834,
	"./muamalat.png": 835,
	"./ocbc-alamin.png": 836,
	"./ocbc.png": 837,
	"./publicbank-islamic.png": 838,
	"./publicbank.png": 839,
	"./rhb-islamic.png": 840,
	"./rhb.png": 841,
	"./sbi-A.png": 842,
	"./sbi-B.png": 843,
	"./sbi-C.png": 844,
	"./standardchartered-saadiq.png": 845,
	"./standardchartered.png": 846,
	"./transparent.png": 847,
	"./uob.png": 848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 808;